<script lang="ts">
	import { Switch } from '../../../../../components/Switch';
	import Txt from '../../../../../components/Txt/Txt.svelte';
	import { filterStores } from '../../../state';
	import type { FilterToggle, FilterDrawerState } from '../../../types';
	import { getFilterCollectionValue } from '../../../utils/getFilterCollectionValue/getFilterCollectionValue';
	import { setFilterCollectionValue } from '../../../utils/setFilterCollectionValue/setFilterCollectionValue';

	interface Props {
		filterCollectionId: string;
		filterToggle: FilterToggle;
	}

	let { filterCollectionId, filterToggle }: Props = $props();

	const { filterStore } = filterStores;

	let value = $derived(
		getFilterCollectionValue<boolean>({
			filterCollectionId,
			filter: $filterStore as FilterDrawerState
		})
	);

	const handleChange = (val: boolean) => {
		setFilterCollectionValue({
			filterCollectionId,
			value: val
		});
	};

	let dataCyPrefix = $derived(`filter-drawer-toggle-id-${filterCollectionId}`);

	let filterToggleId = $derived(`filter-toggle-${filterCollectionId}`);
</script>

<div class="flex items-center justify-between gap-2">
	<div class="flex flex-col">
		<Txt
			component="label"
			variant="label3"
			dataCy={`${dataCyPrefix}-label`}
			for={filterToggleId}
			class="cursor-pointer select-none"
		>
			{filterToggle.label}
		</Txt>

		{#if filterToggle.description}
			<Txt
				component="label"
				for={filterToggleId}
				dataCy={`${dataCyPrefix}-description`}
				variant="body3"
				class="mt-1 cursor-pointer select-none leading-[1rem] text-gray-500"
			>
				{filterToggle.description}
			</Txt>
		{/if}
	</div>

	<div class="contents w-[48px]">
		<Switch id={filterToggleId} dataCy={dataCyPrefix} checked={value} onChange={handleChange} />
	</div>
</div>
